<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-pencil"></i> Sentences</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column">
                <sentences-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="sentences" v-bind:actions="true"></sentences-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import SentenceRepo from '../../repos/SentenceRepo'
import lodash from 'lodash'
import SentencesTable from "./Table";

export default {
  name: 'sentences-view',
  components: {SentencesTable},
  data() {
        return {
            repo: new SentenceRepo(this.$auth),
            sentences: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getUsers();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getUsers();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getUsers();
    },
    onPageChanged(page){
        this.page = page;        
        this.getUsers();
    },
    getUsers(){
        this.repo.paginate(this.page, this.q, this.orderBy).then(response => {            
            this.sentences = response.data.data;
            this.total = response.data.meta.pagination.total_pages            
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sentences/View.vue